import React from 'react';

class AUFClassifications extends React.Component {
  constructor(props) {
    super();

    this.dispatchReducer = props.dispatchReducer.bind(this);

    this._genClassificationItem = this._genClassificationItem.bind(this);
    this._handleSelectChange = this._handleSelectChange.bind(this);
  }

  render() {

    return <fieldset>
      <legend className="sq-form-question-title">Unit level</legend>

      <div className="sq-form-question-answer overflow-scroll">
        <ul>
          {this.props.classifications.map(function(item, i) {

            return this._genClassificationItem(item, i);
          }, this)}
        </ul>
      </div>
      </fieldset>;
  }

  _genClassificationItem(item, i) {
    let itemName = 'classification',
      itemId = 'class-' + item.toLowerCase(),
      value = item === 'All' ? '' : item,
      isChecked = value === this.props.currClassification,
      label = '';

    switch(item) {
    case 'Intermediate':
      label = 'Intermediate';
      break;

    case 'Fundamental':
      label = 'Fundamentals';
      break;

    case 'Advanced':
      label = 'Advanced';
      break;

    case 'All':
      label = 'Critical Content (all units)';
      break;
    }

    return <li key={i}>
      <input type="radio"
             value={item === 'All' ? '' : item}
             name={itemName}
             id={itemId}
             onChange={this._handleSelectChange}
             checked={isChecked}/>

      <label htmlFor={itemId} className="p--bg-white">{label}</label>
    </li>;
  }

  _handleSelectChange(e) {
    let currClass = e.target.value;

    this.dispatchReducer({
      type:       'ALL_UNITS_CLASS::UPDATE',
      value:      currClass,
      fireFilter: true
    });
  }
}

AUFClassifications.propTypes = {
  classifications:    React.PropTypes.array.isRequired,
  currClassification: React.PropTypes.string.isRequired,
  dispatchReducer:    React.PropTypes.func.isRequired
};

export default AUFClassifications;
